import apiService from './index';


export default {
  login(user) {
    return apiService.post('/auth/token/', user);
  },
  fetchDecryptedAPIKey() {
    return apiService.get('/auth/api-key/');
  },
  fetchDecryptedRevokedKey() {
    return apiService.get('/auth/revoked-key/');
  },
  generateAPIKey() {
    return apiService.post('/auth/regenerate_api_key/');
  },
};
